import columns from '../../../../react-table/helpers/columns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export function editRoute(rowInfo) {
  return rowInfo && rowInfo.row ? {
    path: '/edit-route',
    tableId: TableDefinitions.ROUTE_MANAGEMENT_PAGE.id,
    text: 'Edit',
  } : {};
}

export default (data, assetType) => {
  const {
    TextColumn,
    TextCommaColumn,
    EditButtonColumn,
    NavigationColumn,
    BooleanColumn,
    DateColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Outbound Operator', 'outboundOperator').withWidth(80),
        new TextColumn('Outbound IMPC', 'outboundImpc'),
        new TextCommaColumn('Transfer Operator', 'transferOperators').withShow(assetType === 'pallet'),
        new TextCommaColumn('Transfer IMPC', 'transferImpcs').withShow(assetType === 'pallet'),
        new TextColumn('Inbound Operator', 'inboundOperator').withWidth(80),
        new TextColumn('Inbound IMPC', 'inboundImpc'),
        new TextColumn('Priority Type', 'priority'),
        new DateColumn('Start Date', 'startDate'),
        new DateColumn('End Date', 'endDate'),
        new TextColumn('Status', 'status'),
        new TextColumn('Type', 'type'),
        new BooleanColumn('Exceptional Leading Count', 'hasExceptionalLeadingCount').withShow(assetType === 'pallet'),
        new NavigationColumn(new EditButtonColumn('Action', 'editable').withShow('editable'), editRoute),
      ],
    },
  ];
};
